import { Theme } from "@mui/material/styles";

export interface ErrorColorsType {
  backgroundColor: string;
  borderColor: string;
  textColor: string;
}

const statusHue = (status: string) => {
  switch (status) {
    case "success":
      return 170;
    case "unavailable":
      return 46;
    case "offline":
      return 205;
    case "error":
      return 350;
    default:
      return 170;
  }
};

export const errorColors = (theme: Theme, status: string): ErrorColorsType => {
  const hue = statusHue(status);
  const darkMode = theme.palette.mode === "dark";
  return {
    backgroundColor: `hsla(${hue}, 52%, ${darkMode ? 36 : 48}%, ${darkMode ? 0.22 : 0.14})`,
    borderColor: `hsla(${hue}, 52%, ${darkMode ? 58 : 38}%, ${darkMode ? 0.72 : 0.58})`,
    textColor: `hsl(${hue}, 48%, ${darkMode ? 78 : 30}%)`,
  };
};
